import { PayerEngagement } from "@wingspanhq/wingspan-api-sdk";

/**
 * The assignments worth listing: everything except the account's default
 * engagement.
 */
export const selectorNamedPayerEngagements = (
  engagements: PayerEngagement[]
): PayerEngagement[] => engagements.filter(engagement => !engagement.isDefault);
